import create from 'zustand';
import {
  IAssignment,
  IClassroom,
  IQuestionAnswer,
  IStudent,
  ISubmission,
  IUser,
} from '@/components/staffer/Grading/types';

export type QuestionsOptions = 'all' | 'answered' | 'unanswered';
export type ShowHideOptions = 'hide' | 'show';
export type StatusOptions = 'all' | 'graded' | 'ungraded';

type Filters = {
  answerKeyFilter: ShowHideOptions;
  autoGradedFilter: ShowHideOptions;
  questionsFilter: QuestionsOptions;
  statusFilter: StatusOptions;
};

interface GradingStoreTypes {
  assignment: IAssignment;
  classroom: IClassroom;
  currentUser: IUser;
  filters: Filters;
  isLoading: boolean;
  isQuestionMode: boolean;
  isTeacher: boolean;
  programId: number;
  questionAnswers: IQuestionAnswer[];
  questionId: number;
  student: IStudent;
  studentViewAssessmentResults: boolean;
  submission: ISubmission;
  userType: string;
}

interface IQuestionAnswerData {
  id: number;
  score: string;
}

interface UseGradingStoreTypes extends GradingStoreTypes {
  setFilter: (filter) => void;
  setGradingStore: (nextState: Partial<GradingStoreTypes>) => void;
  showAnswers: () => boolean;
  updateQuestionAnswer: (questionAnswerData: IQuestionAnswerData) => void;
}

const useGradingStore = create<UseGradingStoreTypes>((set, get) => ({
  assignment: null,
  classroom: null,
  currentUser: null,
  filters: {
    answerKeyFilter: 'show',
    autoGradedFilter: 'show',
    questionsFilter: 'all',
    statusFilter: 'all',
  },
  isLoading: true,
  isQuestionMode: false,
  isTeacher: false,
  programId: null,
  questionAnswers: null,
  questionId: null,
  setFilter: filter => set(prevState => ({ ...prevState, filters: { ...prevState.filters, ...filter } })),
  setGradingStore: nextState => set(prevState => ({ ...prevState, ...nextState })),
  showAnswers: () => {
    const { assignment, studentViewAssessmentResults, userType } = get();
    const assignmentType = assignment?.assignment_details?.type;

    if (userType === 'Student' && assignmentType === 'Assessment') return studentViewAssessmentResults;

    return true;
  },
  student: null,
  studentViewAssessmentResults: null,
  submission: null,
  userType: null,
  updateQuestionAnswer: (questionAnswerData: IQuestionAnswerData) => set((prevState) => {
    const updatedQuestionAnswers = prevState.questionAnswers.map(qa => (
      qa.id === questionAnswerData.id
        ? { ...qa, ...questionAnswerData }
        : qa
    ));
    return { questionAnswers: updatedQuestionAnswers };
  }),
}));

export default useGradingStore;
